import React, { useState, useEffect } from 'react'
import firebase from '../firebase/config'
import {Link} from 'react-router-dom';

function RestartPassword() {

    const [email, setEmail] = useState('')
	
	const [error, setError] = useState(false)
    const [emessage, setEmessage] = useState("")

    const [success, setSuccess] = useState(false)

    return (
		<div className="container">
			{error 
            ? <div className="alert alert-danger alert-dismissible fade show mb-0 mt-2" role="alert">
                    <button onClick={()=>{setError(false)}} className="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">×</span>
                    </button>
                    <i className="fa fa-exclamation-triangle mx-2"></i>
                    <strong>Cuidado!</strong> {emessage}
                </div>
            : <div></div>
            }
			{success 
            ? <div className="alert alert-success alert-dismissible fade show mb-0 mt-2" role="alert">
                    <button onClick={()=>{setSuccess(false)}} className="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                    <i className="fa fa-check mx-2"></i>
                    <strong>Exito!</strong> El email de recuperación de contraseña ha sido enviado
                </div>
            : <div></div>
            }
			<main className="h-100vh row flow-column align-items-center">
				<form className="login-form-container" onSubmit={e => e.preventDefault() && false }>
					<div className="form-image">
						<img src="../images/logo.png" alt="MKS Salud Aliados Aliados" alt=""/>
					</div>
					<div className="bg-white w-100 text-center rounded p-4">
						
                        <div className="form-group col-lg-12 mb-4">
						    <input type="text" className="form-control" onChange={(e) => setEmail(e.target.value)} placeholder="Email" value={email} />
						</div>
						
						{!success ? <button
							onClick={()=>{resetPassword(email)}}
							className="btn btn-primary btn-block mb-4">
							Recuperar contraseña
						</button>
						: <Link
                            to="/login"
							className="btn btn-success btn-block mb-4">
							Regresar
						</Link> }
						<Link
							to="/login"
							className="color-primary">
							¡Ya la recordé!, regresar
						</Link>
					</div>
				</form>
			</main>
		</div>
    )

    async function resetPassword(email) {
		try {
			await firebase.auth.sendPasswordResetEmail(email)
            setSuccess(true)
			setTimeout(() => {
				setSuccess(false)
			  }, 4000);
		}catch(e){
			console.log(e)
		}
	}

}

export default RestartPassword
